import { render } from "./newletterDownload.vue?vue&type=template&id=189abc2f&scoped=true"
import script from "./newletterDownload.vue?vue&type=script&lang=js"
export * from "./newletterDownload.vue?vue&type=script&lang=js"

import "./newletterDownload.vue?vue&type=style&index=0&id=189abc2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189abc2f"]])

export default __exports__